import { AxiosRequestConfig } from 'axios';
import hamsClient from 'modules/hams';
import { paypalPayload } from 'modules/checkout/review/duck/model';
import { setInteractionError } from '@atlassian/react-ufo/set-interaction-error';
import { CART_SUBMIT_PAYPAL_UFO_NAME } from 'util/ufoNameConstants';

export default async (clientConfig: AxiosRequestConfig, cartUuid: string, payload: paypalPayload) =>
  (
    await hamsClient
      .post(`/1.0/public/order/cart/${cartUuid}/processOrderWithPayPal`, payload, clientConfig)
      .then((r) => {
        if (r.status === 400) {
          setInteractionError(CART_SUBMIT_PAYPAL_UFO_NAME, {
            errorMessage: 'cart submit paypal error',
            name: 'cart submit paypal error',
          });
        }
        return r;
      })
  ).data;
